module.exports = __webpack_public_path__ + "img/default-dljz.ca6ce46f.jpg";